module.exports = __webpack_public_path__ + "img/5.fa778695.png";